<script >

	import { Link } from 'svelte-routing';	
	import { productImg, setState, getState } from '../../stores.js';

	

	let productList = {};
	let AuxProductArray = [];
	let productArray = [];
	let length;

	export let productsOverlay;
	export let countryName = null;


	const countryIndex = {
		'Portugal':0,
		'Spain': 1,
		'France':2,
		'Italy': 3,
		'Greece':4,
		'Morocco':5,
		'Tunisia':6,
	}

	$: {

		if(countryName != null){
			productList	= productImg[countryName]; 

			// productList = JSON.parse(productList);			 

			 AuxProductArray = Object.keys(productList); 
			 length = Object.keys(productList).length;



			 for(let i = 0 ; i < length ; i++){

			 		
			 		if(AuxProductArray[i] != 'partners'){
			 			productArray.push(productList[AuxProductArray[i]]);	

			 			productArray = productArray;	
			 		}
			 		

			 }



			console.log(countryName, ' productList:',productArray);
		}
	}

	let path = '/products/';


	const handleActionBtn = (e) =>{

		var action = e.target.id;


		var currentId = countryIndex[countryName];

		var countryArr = Object.keys(countryIndex);

		if(action == 'back'){

			
			if(currentId == 0){
				currentId = countryArr.length-1;


			}
			else{
				currentId--;
			}


		}
		else if(action == 'next'){

			if(currentId == countryArr.length-1){
				currentId = 0;
			}
			else{
				currentId++;
			}

		}

		// alert(currentId);
		countryName = countryArr[currentId];
		setState('countrySelected',countryName );
		
		productArray = [];
	}

	const closeProduct = (e)=>{

		productsOverlay = false;
		setState('productsOverlay', productsOverlay);
	}

</script>

<div class="productsContainer">

	<div class="side" id="back" on:click={handleActionBtn}>
		<i class="fa-solid fa-caret-left arrow"></i>
	</div>

	<div class="midle">
		
		<div class="titleContainer">

			<div class="title">
				{countryName}
			</div>

			<div class="closeBtn">
				<i class="fa-solid fa-xmark close" on:click={closeProduct}></i>
			</div>
			
		</div>

		<div class="imgContainer">
				

			{#each productArray as src}

				<Link to={path + src.id} >
					<div class="itemContainer">
						<img class="item" src={src.url} alt="background image" />	
					</div>
					<div>
						{src.name}
					</div>

				</Link>


			{/each}

		</div>

	</div>
	<div class="side" id="next" on:click={handleActionBtn}>
		<i class="fa-solid fa-caret-right arrow"></i>
	</div>

</div>



<style >

@media only screen and (min-width: 768px){

	.productsContainer{
		width: 90%;
		height: 60%;
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: flex-start;
		margin-top: -3%;
		/*flex-direction: column;*/
	}


	.side{
		width: 5%;
		height: 15.59%;
		display: flex;
		align-items: center;
		justify-content: center;
		background-color: white;
		opacity: 0.2;
		color: #F6984A;
		border-radius: 50%;

	}

	.side:hover{
		background-color: white;
		opacity: 0.8;
		cursor: pointer;
	}

	.arrow{
		pointer-events: none
	}

	.midle{
		width: 90%;
		height: 100%;
		display: flex;
		flex-direction: column;

	}

	.titleContainer{

		width: 100%;
		height: 16%;
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: space-between;
		
	}

	.title{
		width: auto;
		height: 100%;
		color: #EF9144;
		font-style: normal;
		font-weight: 900;
		font-size: 3.5807291666666665vw;
		display: flex;
		align-items: flex-start;
		justify-content: flex-start;
		/*margin-left: 1%;*/
		/*margin-top: -2%;*/
	    text-shadow:
		   -1px -1px 0 #333333,  
		    1px -1px 0 #333333,
		   -1px 1px 0 #333333,
		    1px 1px 0 #333333;
		/*animation-duration: 1s;
		animation-name: titleShow;
		animation-iteration-count: 1;
		animation-timing-function:cubic-bezier(0.0, 0.0, 1.0, 1.0);*/
		z-index: 40;
		
	}

	.closeBtn{
		width: 5%;
		height: 100%;
		display:flex;
		margin-left: auto;
		align-items: center;
		justify-content: center;
		background-color: transparent;
	}
	.close{
		transform: scale(2);
		cursor: pointer;
	}

	@keyframes titleShow{
		0%{
			text-shadow:
		   -1px -1px 0 #EF9144,  
		    1px -1px 0 #EF9144,
		   -1px 1px 0 #EF9144,
		    1px 1px 0 #EF9144;
		}
		100%{
			text-shadow:
		   -1px -1px 0 #333333,  
		    1px -1px 0 #333333,
		   -1px 1px 0 #333333,
		    1px 1px 0 #333333;
		}
	}

	.imgContainer{
		width: 100%;
		height: 84%;
		display: flex;
		align-items: center;
		justify-content: center;
		gap: 10%;
		flex-wrap: wrap;
	}

	.itemContainer{
		border-radius: 50%;
		background-color: white;
		width:  19.53125vw;
		height: 41.551246537396125vh;
		max-width: 22.786458333333332vw;
		max-height: 48.47645429362881vh ;
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
	}

	.item{
		
		display: flex;
		align-items: center;
		justify-content: center;
		max-width: 55%;
		max-height: 55%;

	}
}
	
</style>




